<div class="ag-grid-chart-wrapper">
  <!-- Chart container where AG Grid will embed the chart -->
  <div #chartContainer class="ag-chart-container"></div>
</div>
